module.exports = __webpack_public_path__ + "assets/img/1801589512665_.pic_hd.329e6ee1.jpg";